import axios from "axios";
import api from "../api";

function create(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(api.shipping, params)
      .then(async (response) => {
        resolve({
          shipping: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function read(params = {}) {
  let pagination = params.with_pagination
    ? params.pagination
      ? `?isPaginated=1&page=${params.pagination.currentPage}&perPage=${params.pagination.perPage}`
      : "?isPaginated=1"
    : "";
  let paginate = params.with_pagination ? { paginate: true } : {};
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.shipping}${pagination}`, params)
      .then((response) => {
        if (params.with_pagination) {
          resolve({
            shippings: { ...paginate, ...response.data },
          });
        } else {
          resolve({
            shippings: response.data,
          });
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function update(body = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.shipping}/${body.id}`, body.params)
      .then(async (response) => {
        resolve({
          shipping: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function destroy(id) {
  return new Promise(async (resolve, reject) => {
    axios
      .delete(`${api.shipping}/${id}`)
      .then((response) => {
        resolve({
          shipping: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function get(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.shipping}/${id}`)
      .then((response) => {
        resolve({
          shipping: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getShippingRules() {
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.shipping_rules}`)
      .then((response) => {
        resolve({
          shippingRules: response.data.rules,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  read,
  create,
  update,
  destroy,
  get,
  getShippingRules
};
